import React from 'react';
import { IconProps } from '../../../../assets/icons/types';

const CupIcon = ({ className, color }: IconProps) => {
  return (
    <svg
      className={className}
      width="34"
      height="27"
      viewBox="0 0 34 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.72852 2.1311V9.99405C6.72852 15.6678 11.2713 20.3746 16.9452 20.4111C18.2952 20.4111 19.6453 20.1557 20.9041 19.6449C22.163 19.134 23.3123 18.3678 24.261 17.4191C25.2279 16.4705 25.9942 15.3211 26.505 14.0806C27.0159 12.84 27.2895 11.49 27.2895 10.1217V2.1311C27.2895 1.82096 27.1618 1.52906 26.9611 1.32838C26.7422 1.10946 26.4503 1 26.1584 1H7.85964C7.5495 1 7.25759 1.1277 7.05691 1.32838C6.83798 1.54731 6.72852 1.8392 6.72852 2.1311Z"
        stroke={color ?? 'current-color'}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.4375 26.1389H21.5778"
        stroke={color ?? 'current-color'}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 20.4307V26.1409"
        stroke={color ?? 'current-color'}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.0342 12.4202H28.439C29.6431 12.4202 30.8107 11.9458 31.6682 11.0884C32.5257 10.2309 33 9.06336 33 7.85929V5.57885C33 5.26871 32.8723 4.97681 32.6716 4.77614C32.4527 4.55721 32.1608 4.44775 31.8689 4.44775H27.2896M7.00228 12.4202H5.561C4.3569 12.4202 3.18928 11.9458 2.33181 11.0884C1.47434 10.2309 1 9.06336 1 7.85929V5.57885C1 5.26871 1.12771 4.97681 1.32839 4.77614C1.54732 4.55721 1.83922 4.44775 2.13113 4.44775H6.71038"
        stroke={color ?? 'current-color'}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.4488 5.782L18.1729 8.11832C18.2332 8.32354 18.4142 8.45772 18.6178 8.45772H20.9709C21.4234 8.45772 21.6195 9.06548 21.2499 9.34963L19.3494 10.794C19.1835 10.9203 19.1156 11.1413 19.1759 11.3465L19.8999 13.6829C20.0432 14.1328 19.5455 14.5116 19.1759 14.2354L17.2754 12.791C17.1094 12.6647 16.8907 12.6647 16.7248 12.791L14.8242 14.2354C14.4547 14.5195 13.9569 14.1407 14.1002 13.6829L14.8242 11.3465C14.8846 11.1413 14.8242 10.9203 14.6508 10.794L12.7502 9.34963C12.3807 9.06548 12.5692 8.45772 13.0293 8.45772H15.3823C15.586 8.45772 15.767 8.32354 15.8273 8.11832L16.5513 5.782C16.6946 5.33211 17.3055 5.33211 17.4488 5.782Z"
        stroke={color ?? 'current-color'}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CupIcon;
